module.exports = {"id":"173703","name":"Rhys Williams","rating":"72","photo":"./data/images/photos/4/173703.png","club":{"name":"Melb. Victory","logo":"./data/images/clubs/Melb.Victory.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RhysWilliams0.json
// module id = 3582
// module chunks = 0